import { render, staticRenderFns } from "./EndMessage.vue?vue&type=template&id=3c122caa&"
import script from "./EndMessage.vue?vue&type=script&lang=js&"
export * from "./EndMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports